import React from "react";
import "../../InvoicingIATA.css";
import NoDataPlaceholder from "../../../../../components/element/NoDataPlaceholder";
import Loader from "../../../../../components/element/Loader";
import ErrorPopup from "../../../../../components/element/ErrorPopup";
import { formatToTwoDecimal, handleEmptyValue } from "../../../../../utils/utils";
import { DATE_FORMAT } from "../../../../../utils/constants";
import dayjs from "dayjs";

const ViewIATAFlightDetailsTable = ({ invoicingData, isLoading, error }) => {
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (invoicingData && invoicingData.length === 0) {
    return <NoDataPlaceholder />;
  }

  return (
    <div className="invoicing-IATA-table-parent-container">
      <div className="invoicing-IATA-table-container">
        <table className="invoicing-IATA-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Client Account Number</th>
              <th>Account Code</th>
              <th>Billing Document</th>
              <th>Client Invoice Reference</th>
              <th>Billing Date</th>
              <th>Payment Method</th>
              <th>IATA Airline Code</th>
              <th>E&F Airline Code</th>
              <th>Airline Name</th>
              <th>Data Currency</th>
              <th>Data Currency Amount</th>
              <th>Location Code</th>
              <th>Charge Description</th>
              <th>Flight No.</th>
              <th>Flight Date</th>
              <th>Aircraft Registration</th>
              <th>Billing Document Type</th>
              <th>Original Invoice Reference</th>
            </tr>
          </thead>
          <tbody>
            {invoicingData?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{handleEmptyValue(item?.clientAccountNumber)}</td>
                <td>{handleEmptyValue(item?.accountCode)}</td>
                <td>{handleEmptyValue(item?.billingDocument)}</td>
                <td>{handleEmptyValue(item?.clientInvoiceReference)}</td>
                <td>{dayjs(item?.billingDate).format(DATE_FORMAT)}</td>
                <td>{handleEmptyValue(item?.paymentMethod)}</td>
                <td>{handleEmptyValue(item?.iataAirlineCode)}</td>
                <td>{handleEmptyValue(item?.efAirlineCode)}</td>
                <td>{handleEmptyValue(item?.airlineName)}</td>
                <td>{handleEmptyValue(item?.dataCurrency)}</td>
                <td>{formatToTwoDecimal(item?.dataCurrencyAmount)}</td>
                <td>{handleEmptyValue(item?.locationCode)}</td>
                <td>{handleEmptyValue(item?.chargeDescription)}</td>
                <td>{handleEmptyValue(item?.flightNo)}</td>
                <td>{dayjs(item?.flightDate).format(DATE_FORMAT)}</td>
                <td>{handleEmptyValue(item?.aircraftRegistration)}</td>
                <td>{handleEmptyValue(item?.billingDocumentType)}</td>
                <td>{handleEmptyValue(item?.originalInvoiceReference)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewIATAFlightDetailsTable;
